import { useState, useEffect } from 'react';

const STORAGE_KEY = 'manualResizeEnabled';

/**
 * Shared on/off switch for manual column-width resizing (see
 * useColumnWidths.js). One flag for the whole app, persisted in
 * localStorage, defaulting to off - columns auto-size to their content
 * until the user deliberately opts in to setting widths by hand. Turning
 * this off doesn't discard any widths already set; it just stops applying
 * them, so turning it back on restores exactly what was there before.
 */
export const useManualResizeEnabled = () => {
  const [manualResizeEnabled, setManualResizeEnabled] = useState(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved !== null ? JSON.parse(saved) : false;
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(manualResizeEnabled));
  }, [manualResizeEnabled]);

  return [manualResizeEnabled, setManualResizeEnabled];
};

export default useManualResizeEnabled;
